import React from "react";
import { useTranslation } from "react-i18next";
import * as moment from "moment";
import "moment/locale/es";

export const PublishDate = ({ className, date }) => {
  //Language hooks
  const { i18n } = useTranslation("common");
  const lang = i18n.language;

  moment.locale(lang);
  let published = moment(date, "YYYYMMDD hh:mm:ss").startOf("minute").fromNow();

  return date ? (
    <time className={className} itemProp="datePublished" dateTime={date}>
      {published}
    </time>
  ) : (
    ""
  );
};
